import { useCallback } from "react";
import { sendingSignInCodeAsnyc } from "../../../../../store/login/loginSlice";
import { ErrorType } from "../../../../../types/error";
import { useAppDispatch, useModal } from "../../../../../hooks/hooks";
import { RequestCodeType } from "../../../../../types/auth";
import {useTranslation} from "react-i18next";

export function useCodeSender() {
  const dispatch = useAppDispatch();
  const {t} = useTranslation("modal");
  const { openAlertModal } = useModal();

  const sendCode = useCallback(
    async (email: string, type: RequestCodeType) => {
      try {
        return await dispatch(sendingSignInCodeAsnyc({ email: email.trim(), requestCodeType: type })).unwrap();
      } catch (error) {
        const errorType: ErrorType = JSON.parse((error as Error).message);
        switch (errorType?.errorCode?.httpCode) {
          case 462:
            openAlertModal({
              title: t("notice.title"),
              desc: t("notice.desc"),
            });
            break;
          default:
            console.error(error);
            openAlertModal(null);
            break;
        }
        throw error;
      }
    },

    [dispatch, openAlertModal, t]
  );

  return {
    sendCode,
  };
}
